<template>
    <div
        class="algolia-listing-product-block__product-combination-promotion"
        :class="name === 'op'
            ? 'algolia-listing-product-block__product-combination-promotion--green'
            : 'algolia-listing-product-block__product-combination-promotion--red'"
    >
        <span v-if="name === 'op'">{{ this.$t('combinationPromotion.op') }}</span>
        <span v-else-if="name === 'bonus'">{{ this.$t('combinationPromotion.bonus') }}</span>
        <span v-else-if="name === '2plus1free'">{{ this.$t('combinationPromotion.twoPlusOneFree') }}</span>
        <span v-else-if="name === 'minus10percent'">{{ this.$t('combination.minusTenPercent') }}</span>
        <span v-else-if="name === 'minus20percent'">{{ this.$t('combination.minusTwentyPercent') }}</span>
        <span v-else-if="name === 'minus25percent'">{{ this.$t('combination.minusTwentyFivePercent') }}</span>
        <span v-else-if="name === 'minus30percent'">{{ this.$t('combination.minusThirtyPercent') }}</span>
        <span v-else-if="name === 'minus40percent'">{{ this.$t('combination.minusFortyPercent') }}</span>
        <span v-else-if="name === 'minus50percent'">{{ this.$t('combination.minusFiftyPercent') }}</span>
        <span v-else-if="name === 'minus60percent'">{{ this.$t('combination.minusSixtyPercent') }}</span>
        <span v-else-if="name === 'minus70percent'">{{ this.$t('combination.minusSeventyPercent') }}</span>
    </div>
</template>

<script>
export default {
    name: "ProductCombinationPromotionText",
    props: {
        name: String,
    }
};
</script>
